export const GET_SUBACCOUNTS = 'GET_SUBACCOUNTS';
export const SET_SUBACCOUNTS_PAGINATION = 'SET_SUBACCOUNTS_PAGINATION';
export const SET_SUBACCOUNTS_FILTERS = 'SET_SUBACCOUNTS_FILTERS';
export const RESET_SUBACCOUNTS = 'RESET_SUBACCOUNTS';
export const TOGGLE_SUBACCOUNT = 'TOGGLE_SUBACCOUNT';
export const ADD_SUBACCOUNT = 'ADD_SUBACCOUNT';
export const UPDATE_SUBACCOUNT = 'UPDATE_SUBACCOUNT';
export const GET_SUBACCOUNT_BY_ID = 'GET_SUBACCOUNT_BY_ID';
export const RESET_SUBACCOUNT_FORM = 'RESET_SUBACCOUNT_FORM';
export const GET_SUBACCOUNT_FORM_CONFIG = 'GET_SUBACCOUNT_FORM_CONFIG';
export const MODIFY_EDITING_SUBACCOUNT = 'MODIFY_EDITING_SUBACCOUNT';
export const ADD_CUSTOM_FIELD_EDITING_SUBACCOUNT = 'ADD_CUSTOM_FIELD_EDITING_SUBACCOUNT';
export const REMOVE_CUSTOM_FIELD_EDITING_SUBACCOUNT = 'REMOVE_CUSTOM_FIELD_EDITING_SUBACCOUNT';

//Groups
export const MODIFY_CUSTOM_FIELD_EDITING_SUBACCOUNT = 'MODIFY_CUSTOM_FIELD_EDITING_SUBACCOUNT';



// WEBPACK FOOTER //
// src/modules/secured/modules/subaccounts/constants/subaccounts_constants.js